/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `DxpSignupStatusCode*`'s.
 */
export type DxpSignupStatusCode = DxpSignupStatusCodeDone | DxpSignupStatusCodeExpired | DxpSignupStatusCodePending;

/**
 * The user has completed the signup flow.
 * @export
 */
export type DxpSignupStatusCodeDone = typeof DXP_SIGNUP_STATUS_CODE_DONE;

/**
 * The invitation to sign up has expired.
 * @export
 */
export type DxpSignupStatusCodeExpired = typeof DXP_SIGNUP_STATUS_CODE_EXPIRED;

/**
 * The user has not signed up, but the invitation is still valid.
 * @export
 */
export type DxpSignupStatusCodePending = typeof DXP_SIGNUP_STATUS_CODE_PENDING;

/**
 * The status code to describe that signup is done.
 * @export
 */
export const DXP_SIGNUP_STATUS_CODE_DONE = `Done`;

/**
 * The status code to describe that this signup flow has expired.
 * @export
 */
export const DXP_SIGNUP_STATUS_CODE_EXPIRED = `Expired`;

/**
 * The status code to describe that the signup flow is pending.
 * @export
 */
export const DXP_SIGNUP_STATUS_CODE_PENDING = `Pending`;
